import { useNavigate, useSearchParams } from "react-router-dom";
import { useMutation, useQueryClient } from "react-query";
import { axiosInstance, axiosInstance2 } from "helpers/axiosInstance";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "store";

const useCreateBooking = () => {
	const [couponCode, setCouponCode] = useState("");
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	useEffect(() => {
		setCouponCode(searchParams.get("coupon"));
	}, [searchParams]);
	const {
		state: { currentUser },
	} = useContext(UserContext);
	return useMutation(
		(bookingData) => {
			return axiosInstance2({
				method: "post",
				url: "/manageBookings/createBooking",
				data: {
					...bookingData,
					COUPON_CODE: couponCode,
				},
				headers: {
					Authorization: `Bearer ${localStorage.getItem("token")}`,
				},
			});
		},
		{
			onSuccess: (data) => {
				if (currentUser.email.includes("@saffronstays.com")) {
					window.location.href =
						"/old-booking/" +
						data.data.data?.BOOKING_ID +
						`?coupon=${couponCode}`;
					return;
				}
				window.location.href =
					"/booking/" + data.data.data?.BOOKING_ID + `?coupon=${couponCode}`;
			},
		},
	);
};

export default useCreateBooking;
